import React, { memo } from 'react'

const ReadOnly = ({ label, value, className }) => {
    return (
        <div className={`readOnly ${className}`}>
            <span className={'readOnly__label'}>{label}</span>
            <span>{value}</span>
        </div>
    )
}

export default memo(ReadOnly)
